import { Modal } from '@/components/Modal'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { MdClose, MdPhoneDisabled, MdOutlineSecurity } from 'react-icons/md'
import * as S from './VoiceModals.styles'

type Props = {
  isOpen: boolean
  denied: boolean
  onClose: () => void
}

export function CallPermissionValidationModal({ isOpen, denied, onClose }: Props) {
  const { t } = useTranslation()
  return (
    <Modal
      isOpen={isOpen}
      closeModal={denied ? onClose : () => undefined}
      onBackgroundClick={denied ? onClose : () => undefined}
      onEscapeKeydown={denied ? onClose : () => undefined}
      hideHeaderCloseButton
    >
      <S.ValidationFrame role="dialog" aria-modal="true" aria-labelledby="voice-permission-validation-title">
        <S.ValidationBody>
          <S.ValidationIcon $denied={denied}>
            {denied ? <MdPhoneDisabled size={30} /> : <MdOutlineSecurity size={30} />}
          </S.ValidationIcon>
          {!denied && <S.ValidationSpinner aria-hidden="true" />}
          <h2 id="voice-permission-validation-title">
            {denied
              ? t('translation:voice.permission.validationDeniedTitle')
              : t('translation:voice.permission.validationTitle')}
          </h2>
          <p>
            {denied
              ? t('translation:voice.permission.validationDeniedDescription')
              : t('translation:voice.permission.validationDescription')}
          </p>
          {denied && (
            <S.Button type="button" onClick={onClose} autoFocus>
              <MdClose size={18} /> {t('translation:voice.permission.close')}
            </S.Button>
          )}
        </S.ValidationBody>
      </S.ValidationFrame>
    </Modal>
  )
}
